var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7343 44.7394C50.1481 42.6498 48.7895 40.6204 46.6999 40.2067C44.6103 39.7929 42.5809 41.1515 42.1671 43.2411C41.7534 45.3307 43.1119 47.3601 45.2016 47.7738C47.2912 48.1876 49.3206 46.829 49.7343 44.7394Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7031 53.4114L38.1488 54.2412C38.3946 54.6714 38.5329 55.1632 38.5944 55.6549L39.0554 59.8193",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0839 49.9391L39.1016 46.3433",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4385 60.4348L54.4373 54.5954L59.6774 43.6543C60.2306 42.4865 60.0615 41.1188 59.2471 40.12L53.2233 32.8054C52.3628 31.7605 50.8108 31.5915 49.7505 32.4366C48.6441 33.2972 48.475 34.9107 49.3663 35.9863L54.7907 42.6094L51.364 49.0634",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.222 48.0392C17.2686 47.4485 18.4488 45.3104 17.8581 43.2638C17.2674 41.2172 15.1294 40.0369 13.0827 40.6277C11.0361 41.2184 9.85584 43.3564 10.4466 45.403C11.0373 47.4497 13.1753 48.6299 15.222 48.0392Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.569 53.2131L22.0004 54.2427C21.7545 54.673 21.6162 55.1647 21.5548 55.6564L21.0938 59.8208",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3398 49.4627L21.0609 46.3433",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73895 60.4339L5.64792 54.6252L0.269567 43.3768C-0.191434 42.3933 -0.0531334 41.2408 0.623002 40.3957L6.69285 32.9428C7.52266 31.9286 8.98249 31.6981 10.0735 32.4203C11.3336 33.2501 11.6102 35.0019 10.6421 36.1698L5.40205 42.5624L8.36782 48.1405",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0645 19.5119L32.23 0.0115759C35.288 -0.095991 38.4996 0.549411 41.2503 1.80948C44.5695 3.33079 48.5033 3.94545 52.0377 3.46909L49.6558 16.5001V16.5308C46.1061 17.0072 42.1723 16.4079 38.8531 14.8712C37.2395 14.1336 35.4877 13.6111 33.6898 13.3192",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8021 41.7184L28.1448 43.4548C26.3469 44.3154 25.6246 46.4974 26.5774 48.2492C26.7464 48.5566 27.1152 48.6949 27.4379 48.5566L34.399 45.6369C37.9641 44.2232 38.3636 39.3365 35.0905 37.3542L29.7583 34.1119L29.0514 19.8977C29.036 19.4981 28.698 19.1754 28.2984 19.1754C26.1778 19.1754 24.4721 20.9119 24.5182 23.0325L24.7948 35.5717L24.0726 36.8471C22.9662 38.8448 22.582 41.1498 22.9969 43.3934",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1277 30.4253C40.5 28.5957 39.3185 26.8108 37.4889 26.4385C35.6593 26.0663 33.8744 27.2477 33.5021 29.0773C33.1299 30.9069 34.3113 32.6919 36.1409 33.0641C37.9705 33.4364 39.7555 32.2549 40.1277 30.4253Z",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.416 48.6033V59.2063",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.625 53.8735V59.2058",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiot);
export default __webpack_public_path__ + "static/media/riot.66698369.svg";
export { ForwardRef as ReactComponent };